var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2857 15.7857C23.8242 15.7857 25.0714 14.5385 25.0714 13C25.0714 11.4615 23.8242 10.2143 22.2857 10.2143C20.7472 10.2143 19.5 11.4615 19.5 13C19.5 14.5385 20.7472 15.7857 22.2857 15.7857Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.7857C14.5386 15.7857 15.7858 14.5385 15.7858 13C15.7858 11.4615 14.5386 10.2143 13.0001 10.2143C11.4616 10.2143 10.2144 11.4615 10.2144 13C10.2144 14.5385 11.4616 15.7857 13.0001 15.7857Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7143 15.7857C5.25281 15.7857 6.50002 14.5385 6.50002 13C6.50002 11.4615 5.25281 10.2143 3.7143 10.2143C2.1758 10.2143 0.928589 11.4615 0.928589 13C0.928589 14.5385 2.1758 15.7857 3.7143 15.7857Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.85714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d69907e6df1416ae7b8f919b1f749db8.svg";
export { ForwardRef as ReactComponent };